const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {
			tags: true
		},
		buttonContext: 'address',
		renderEmptyBeforReady: true,
		inline: true,
		maxNrOfExportElements: 500000
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'addressID',
				direction: 'desc'
			}]
		}
	},

	methods: {
		async export(){
			const context = await this.performDecision(
				'chooseExportType',
				{
					component:  	this,
					title:      	storage.__('addresses.export.chooseType.title'),
					message:    	storage.__('addresses.export.chooseType.message'),
					showLineFeeds: 	true
				}
			)

			if(context.decision.type !== 'export'){
				console.error('INVALID TYPE')
				return
			}

			if(
				context.decision.mode !== 'label' &&
				context.decision.mode !== 'newsletter' &&
				context.decision.mode !== 'addresses'
			) {
				console.error('INVALID MODE')
				return
			}

			const nrOfMatchingElements = ((((this.resourceData || {}).nrOfElements || {}).data || {}).attributes || {}).nrOfMatchingElements || 0
			if(nrOfMatchingElements > this.config.maxNrOfExportElements){
				const confirmationContext = await this.performDecision(
					'confirm',
					{
						component:  this,
						title:      storage.__('hint.artCrm.address.' + context.decision.mode + '.export.limit.title'),
						message:    storage.__('hint.artCrm.address.' + context.decision.mode + '.export.limit.message', { max: this.config.maxNrOfExportElements, nrOfMatchingElements, })
					}
				)

				if(confirmationContext.decision.type !== 'yes'){
					return
				}
			}

			if(context.decision.mode === 'newsletter'){
				const resourceFilters 	= this.getResourceFilters(storage, undefined, 'refreshResources') || {}
				const hasActiveNewsletterEmail = (resourceFilters.filters || {}).hasActiveNewsletterEmail
				if(hasActiveNewsletterEmail !== undefined && !hasActiveNewsletterEmail){
					return this.performMessage({
						messageDisplay: {
							message: 'error:artCrm.addresses.export.newsletterWithoutEmailsWillBeEmptyAllTheTime.message'
						}
					})
				}
			}

			this.startExport(context.decision.mode)
		},

		loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			const nrOfFilters = utils.collectionSize((resourceFilters || {}).filters)
			return actionKey !== 'refreshResources' || nrOfFilters > 1 || (nrOfFilters > 0 && resourceFilters.tags_tagConnection === undefined);
		},

		startExport: function(mode, forceExtension){
			const resourceFilters 	= utils.copy(this.getResourceFilters(storage, undefined, 'refreshResources')) || {}
			resourceFilters.offset 	= 0
			resourceFilters.limit 	= this.config.maxNrOfExportElements
			const filename = 'art_crm_addresses_' + utils.moment().format('YYYY-MM-DD_hh-mm-ss') + '.xlsx'
			window.open('/LTR/~/exports/art_crm/addresses/' + (mode || '-') + '/' + filename + '?body=' + Buffer.from(JSON.stringify({
				resourceFilters
			})).toString('base64'), '_blank')
		},

		showInsert: function(){
			return getComponent('artCrmController').showInsert('address');
		},

		showEdit: function(addressID, addressData){
			if(((this.model.controller || {}).config || {}).usage === 'selection') {
				return this.triggerClosest('onDecision', {
					decisionType: 'addressSelected',
					decisionComponent: this,
					addressID,
					addressData
				});
			}
			return getComponent('artCrmController').showEdit('address', addressID, addressData);
		},

		async assignTagsByFilter(pickedTagOptions){

			if(!pickedTagOptions){
				// choose tags
				if(!this.model.tagPickerButton){
					this.model.tagPickerButton = getComponent(
						this.$
							.closest('.templates_artCrm_entity_controller')
							.find('section .base_form_fields_tag-picker-button'),
						true
					)
				}
				if(!this.model.tagPickerButton){
					return console.warn('tagPickerButton not found')
				}
				this.model.tagPickerButton.open([], options => this.assignTagsByFilter(options), undefined, undefined, false, true)
				return
			}

			const resourceFilters 	= {
				filters: (utils.copy(this.getResourceFilters(storage, undefined, 'refreshResources')) || {}).filters,
				newTags: {},
			}

			// assign tags
			resourceFilters.newTags = utils.map((pickedTagOptions.decisionOptions || {}).dirtyAssignedTags || {}, tag => tag.type === 'create' ? ({
				categoryID: tag.categoryID,
				categoryDataID: tag.categoryDataID,
			}) : undefined)

			await this.performAction(
				this.prepareAction('assignTagsByFilters', undefined, undefined, {
					source: {
						load: {
							resourceFilters
						}
					}
				})
			)

			const statusController = getComponent('statusController', true)
			if(statusController) {
				statusController.addPanel('status.done.tagsAssigned')
			}

			this.callHandler('recordControllerResourcesModified')
			this.callHandler('massAssignTags')
		},

		addEntity: function(entity){
			// add entity to dom if necessary
			if(this.config.isReady && this.model.$table){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }))
			}
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_artCrm_entity_controller', function(controller){
					self.model.controller = controller
				});
			}

			self.model.$table = $element.find('table');
		}
	},

	handlers: [{
		name: 'recordControllerResourcesModified',
		handle: function(callerComponent) {
			if(this.config.isReady){
				this.refreshData();
			}
		}
	}]
}